/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('des.single-item-map', function (el) {
        var options = JSON.parse(el.dataset.mapOptions);
        moya.map.osmMap.setZoom(options.zoom);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
